// Account Receivable States

export default {
  accountReceivableList: [],
  accountReceivableInfo: {},
  accountReceivableBalanceDetails: {}
}
